export const GET_USER_LOYALTY_PENDING = 'GET_USER_LOYALTY_PENDING';
export const GET_USER_LOYALTY_SUCCESS = 'GET_USER_LOYALTY_SUCCESS';
export const GET_USER_LOYALTY_FAILED = 'GET_USER_LOYALTY_FAILED';
export const GET_RESTAURANT_LOYALTY_PENDING = 'GET_RESTAURANT_LOYALTY_PENDING';
export const GET_RESTAURANT_LOYALTY_SUCCESS = 'GET_RESTAURANT_LOYALTY_SUCCESS';
export const GET_RESTAURANT_LOYALTY_FAILED = 'GET_RESTAURANT_LOYALTY_FAILED';
